<template>
  <nav class="navbar is-primary" id="navbar">
    <div class="navbar-brand">
      <div class="navbar-item">
        <GoBackButton id="go-back-button" />
      </div>

      <AppLogo id="app-logo" />

      <div class="navbar-burger-wrapper">
        <div
          class="navbar-burger"
          @click="showNav = !showNav"
          :class="{ 'is-active': showNav }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div
      id="navbarMenuBody"
      class="navbar-menu"
      :class="{ 'is-active': showNav }"
    >
      <div class="navbar-start"></div>
      <div class="navbar-item center-content">
        <SearchBar id="search-bar" />
      </div>
      <div class="navbar-end">
        <div class="navbar-item">
          <FeedbackButton id="feedback-button" />
        </div>
        <div class="navbar-item">
          <AddToSlackButton id="add-to-slack-button" />
        </div>
        <div class="navbar-item">
          <UserMenu id="user-menu" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import GoBackButton from "@/components/GoBackButton.vue";
import AppLogo from "@/components/AppLogo.vue";
import SearchBar from "@/components/SearchBar.vue";
import FeedbackButton from "@/components/FeedbackButton.vue";
import AddToSlackButton from "@/components/AddToSlackButton.vue";
import UserMenu from "@/components/UserMenu.vue";
export default {
  name: "navigation-bar",
  components: {
    GoBackButton,
    AppLogo,
    SearchBar,
    FeedbackButton,
    AddToSlackButton,
    UserMenu
  },
  data() {
    return {
      showNav: false
    };
  }
};
</script>

<style scoped>
.navbar {
  border-bottom: 1px solid lightgray;
  background-color: white;
  height: 57px;
}

.navbar-burger-wrapper {
  padding: 2px 4px 0 4px;
  cursor: pointer;
  display: block;
  position: relative;
}

.navbar.is-primary .navbar-burger {
  color: #6b6b6b;
  background-color: white;
}
.navbar.is-primary .navbar-burger:hover {
  color: #6b6b6b;
}
.navbar.is-primary .navbar-burger span {
  height: 2px;
}

#search-bar {
  max-width: 60vh;
  width: 500px;
}

.center-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
</style>
